import { render, staticRenderFns } from "./ComponentShowcase.vue?vue&type=template&id=6326c858&scoped=true"
import script from "./ComponentShowcase.vue?vue&type=script&lang=js"
export * from "./ComponentShowcase.vue?vue&type=script&lang=js"
import style0 from "./ComponentShowcase.vue?vue&type=style&index=0&id=6326c858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6326c858",
  null
  
)

export default component.exports